import { Component, Prop, h } from '@stencil/core';

export enum AspectRatio {
  auto = 'auto',
  square = 'square',
  video = 'video',
  videoVertical = 'video-vertical',
}

export enum BackgroundColor {
  brand = 'brand',
  emphasis = 'emphasis',
  none = 'transparent',
}

@Component({
  tag: 'amp-image',
  styleUrls: ['../../base.css', 'image.css'],
  shadow: true,
})
export class AmpImage {
  /**
   * Img src URL for the background image
   */
  @Prop() backgroundSrc: string;
  /**
   * Img src URL for the foreground image
   */
  @Prop() foregroundSrc: string;
  /**
   * Background color: brand, emphasis (will be hidden if backgroundSrc image is applied)
   */
  @Prop() backgroundColor: BackgroundColor;
  /**
   * Aspect Ratio for the image: auto (default), square, video, video-vertical
   */
  @Prop() aspectRatio: AspectRatio;
  /**
   * Alt for the background image
   */
  @Prop() backgroundAlt: string;
  /**
   * Alt for the foreground image
   */
  @Prop() foregroundAlt: string;
  /**
   * Point of Interest X Coordinate
   */
  @Prop() poiX: number;
  /**
   * Point of Interest Y Coordinate
   */
  @Prop() poiY: number;

  render() {
    const backgroundSrc = this.backgroundSrc;
    const foregroundSrc = this.foregroundSrc;
    const backgroundColor = this.backgroundColor || BackgroundColor.none;
    const aspectRatio = this.aspectRatio || AspectRatio.auto;
    const backgroundAlt = this.backgroundAlt;
    const foregroundAlt = this.foregroundAlt;
    const poiX = this.poiX;
    const poiY = this.poiY;

    return (
      <div class={`flex items-center justify-center relative overflow-hidden w-full h-full p-4 bg-${backgroundColor} aspect-${aspectRatio}`}>
        <img
          src={backgroundSrc}
          class="absolute w-full h-full object-cover"
          alt={backgroundAlt}
          style={{ objectPosition: poiX && poiY ? `${poiX * 100}% ${poiY * 100}%` : 'initial' }}
        ></img>
        <img src={foregroundSrc} class="z-10 object-contain w-full max-h-[100px]" alt={foregroundAlt}></img>
      </div>
    );
  }
}
